export const es = {
  title: 'Potencial de velocidad del viento',
  subtitle: '1 km, global, DTU/Grupo del Banco Mundial/ESMAP',
  download_data: '',
  learn_more: '',
  content: [
    {
      label: 'Función',
      value: 'Velocidad media del viento para cualquier lugar de la Tierra',
    },
    {
      label: 'Resolución',
      value: '1 km',
    },
    {
      label: 'Cobertura geográfica',
      value: 'Global',
    },
    {
      label: 'Fuente',
      value: '\tDTU/Grupo del Banco Mundial/ESMAP',
    },
    {
      label: 'Frecuencia de actualizaciones',
      value: '',
    },
    {
      label: 'Fecha del contenido',
      value: '',
    },
    {
      label: 'Precauciones',
      value:
        'El GWA utiliza dos componentes principales de modelado que pueden introducir incertidumbre en los cálculos. Estos componentes son el modelado de mesoescala y el modelado a microescala.',
    },
    {
      label: 'Licencia',
      value: '[CC 4.0](https://creativecommons.org/licenses/by/4.0/)',
    },
  ],
  overview: {
    label: 'Descripción',
    value:
      'El conjunto de datos de velocidad media del viento del Atlas Eólico Mundial (GWA) fue generado por el Departamento de Energía Eólica de la Universidad Técnica de Dinamarca (DTU), el Grupo del Banco Mundial y el Programa de Asistencia para la Gestión del Sector Energético (ESMAP).\n\nLa velocidad media del viento es uno de los indicadores clave de rendimiento de la producción de energía eólica. GWA comienza con datos de velocidad del viento de baja resolución y los convierte en datos de alta resolución mediante un proceso de reducción de escala. El resultado de este proceso es un modelo de los climas eólicos locales en todo el globo (excepto los polos norte y sur y las áreas oceánicas lejanas en alta mar) con una resolución de 1 kilómetro para tres alturas: 50 metros, 100 metros y 200 metros.',
  },
  citation: {
    label: 'Citación',
    value:
      'Data/information/map obtained from the Global Wind Atlas 2.0, a free, web-based application developed, owned and operated by the Technical University of Denmark (DTU) in partnership with the World Bank Group, utilizing data provided by Vortex, with funding provided by the Energy Sector Management Assistance Program (ESMAP). For additional information: https://globalwindatlas.info. Accessed through Resource Watch, (date)',
  },
};
